/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UpgradeRuleResponse,
    UpgradeRuleResponseFromJSON,
    UpgradeRuleResponseFromJSONTyped,
    UpgradeRuleResponseToJSON,
} from './UpgradeRuleResponse';

/**
 * 
 * @export
 * @interface UpgradeRulesResponse
 */
export interface UpgradeRulesResponse {
    /**
     * 
     * @type {Array<UpgradeRuleResponse>}
     * @memberof UpgradeRulesResponse
     */
    elements: Array<UpgradeRuleResponse>;
    /**
     * 
     * @type {number}
     * @memberof UpgradeRulesResponse
     */
    totalElementCount: number | null;
}

export function UpgradeRulesResponseFromJSON(json: any): UpgradeRulesResponse {
    return UpgradeRulesResponseFromJSONTyped(json, false);
}

export function UpgradeRulesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgradeRulesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': ((json['elements'] as Array<any>).map(UpgradeRuleResponseFromJSON)),
        'totalElementCount': json['totalElementCount'],
    };
}

export function UpgradeRulesResponseToJSON(value?: UpgradeRulesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': ((value.elements as Array<any>).map(UpgradeRuleResponseToJSON)),
        'totalElementCount': value.totalElementCount,
    };
}

